import type { ColorTokenKey } from 'smoothie';

export const DONUT_PALETTE: ColorTokenKey[] = [
    '$leaf',
    '$water',
    '$petal',
    '$lemon',
    '$peach',
];

export const getHorizontalBarColorToken = (
    value: number,
    maximumValue: number,
): ColorTokenKey => {
    const ratio = maximumValue <= 0 ? 0 : value / maximumValue;

    if (ratio >= 0.75) {
        return '$leafDarkest';
    }

    if (ratio >= 0.5) {
        return '$leafDark';
    }

    if (ratio >= 0.25) {
        return '$leaf';
    }

    return '$leafLight';
};
